import { StorageKeys } from "@utils/enums";
import { SafeLocalStorage } from "@utils/localStorage";

class PreferredStoreService {
    static getPreferredStoreOfTheUser() {
        return SafeLocalStorage.getItem(
            StorageKeys.PreferredStoreLocalStorageKey,
        );
    }

    static setPreferredStoreOfTheUser(storeId: string) {
        SafeLocalStorage.setItem(
            StorageKeys.PreferredStoreLocalStorageKey,
            storeId,
        );
    }

    static removePreferredStoreOfTheUser() {
        SafeLocalStorage.removeItem(StorageKeys.PreferredStoreLocalStorageKey);
    }

    static setLastKnownCartStoreId(storeId: string) {
        SafeLocalStorage.setItem(StorageKeys.CartStoreLocalStorageKey, storeId);
    }

    static getLastKnownCartStoreId() {
        return SafeLocalStorage.getItem(StorageKeys.CartStoreLocalStorageKey);
    }

    static removeLastKnownCartStoreId() {
        return SafeLocalStorage.removeItem(
            StorageKeys.CartStoreLocalStorageKey,
        );
    }

    static cleanUpPreferredStores() {
        this.removeLastKnownCartStoreId();
        this.removePreferredStoreOfTheUser();
    }
}

export { PreferredStoreService };
